import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom/client';
import './_common.scss';
import './_custom_antd.scss'
import './_animate.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppContextProvider } from '@utils/AppContext';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import "./i18n/config";
import 'dayjs/locale/zh-cn';
import PSAISpinDot from './PSAIComponents/PSAISpinDot';
import Utils from './utils/utils';
import './upload-polyfill'
import './fabric'
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
dayjs.locale('zh-cn');

// 移动端&PC端适配，相互跳转
if (Utils.isMobileDevice()) {
    if (!/^\/mobile/.test(location.pathname) && !/^\/activity/.test(location.pathname)) {
        window.location.replace('/mobile/' + location.search)
    }
} else {
    if (/^\/mobile/.test(location.pathname)) {
        window.location.replace('/' + location.search)
    }
}

Spin.setDefaultIndicator(<PSAISpinDot />)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ConfigProvider locale={zhCN} theme={{
            cssVar: true,
            hashed: false,
            token: {
                "colorPrimary": "#006eff",
                "colorInfo": "#006eff",
                "colorSuccess": "#34c759",
                "colorWarning": "#ffbc3f",
                "colorError": "#ff3b30",
                "colorTextBase": "#000812",
                "borderRadius": 8,
                "wireframe": false
            },
            components: {
                "Select": {
                    "controlHeightSM": 22
                },
                Table: {
                    /* 这里是你的组件 token */
                    headerBg: "var(--gray-light)",
                    rowHoverBg: "transparent",
                    rowSelectedBg: "transparent",
                    rowSelectedHoverBg: "transparent",
                    headerSplitColor: "transparent",
                    borderColor: "transparent"
                },
                "Button": {
                    "controlHeight": 36,
                    "paddingInline": 25,
                    "defaultBorderColor": "var(--gray-lgray)",
                    "borderColorDisabled": "var(--gray-lgray)",
                    "colorBorder": "var(--gray-lgray)",
                }
            },
        }}>
            <AppContextProvider>
                <DndProvider backend={HTML5Backend}>
                    <App />
                </DndProvider>
            </AppContextProvider>
        </ConfigProvider>

    </BrowserRouter>
);

reportWebVitals((res) => {
    // console.log(res.name, res.value)
});


